import { TooltipState } from "./types";

// Global state for tooltip - outside of any component
export const globalTooltipState: TooltipState = {
  visible: false,
  text: "Click to copy",
  position: { top: 0, left: 0 },
  tooltipUpdateCallback: null,
};

// Functions to update tooltip without re-rendering the table
export const showGlobalTooltip = (
  event: MouseEvent | React.MouseEvent,
  textToCopy: string,
) => {
  const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
  globalTooltipState.visible = true;
  globalTooltipState.text = "Click to copy";
  globalTooltipState.position = {
    top: rect.top + window.scrollY - 30,
    left: rect.left + window.scrollX,
  };
  if (globalTooltipState.tooltipUpdateCallback) {
    globalTooltipState.tooltipUpdateCallback();
  }
};

export const hideGlobalTooltip = () => {
  globalTooltipState.visible = false;
  if (globalTooltipState.tooltipUpdateCallback) {
    globalTooltipState.tooltipUpdateCallback();
  }
};

export const updateGlobalTooltipText = (text: string) => {
  globalTooltipState.text = text;
  if (globalTooltipState.tooltipUpdateCallback) {
    globalTooltipState.tooltipUpdateCallback();
  }
};
